import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { extend, extend_page, extend_count, backend } from "../../components/apipath";
import { dateHelper } from "../../modules/helpers";
import Swal from "sweetalert2";

function ExtendRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);

    /** 讀取展延申請記錄 */
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const response = await axios.get(`${extend_page(page - 1, rows)}`, { headers: { token } });
            const data = response.data;
            console.log("Response Data (fetchData):", data); 
            setRequestList(data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };

    

    const fetchPageData = async () => {
        try {
            const response = await axios.get(`${extend_count}`, { headers: { token } });
            console.log("Response Data (fetchPageData):", response.data);
            if (response.data && response.data[0]) {
                setRowsCount(response.data[0].total || 0);
            }
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);

    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    /** 進入編輯模式 */
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    /** 處理輸入變更 */
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUpdatedData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    /** 儲存變更 */
    const saveChanges = async () => {
        try {
          const dataToSend = {
            ...updatedData,
            request_id: editingRequest.request_id
          };
      
          await axios.put(`${extend}`, dataToSend, {
            headers: {
              token: token,
              Authorization: `Bearer ${token}`
            }
          });
      
          setRequestList((prevList) =>
            prevList.map((req) =>
              req.request_id === editingRequest.request_id ? dataToSend : req
            )
          );
      
          setEditingRequest(null);
          Swal.fire({
            icon: "success",
            title: "更新成功",
            confirmButtonText: "確認"
          });
        } catch (error) {
          console.error("Error updating requestList:", error);
          Swal.fire({
            icon: "error",
            title: "更新失敗",
            text: "請稍後再試",
            confirmButtonText: "確認"
          });
        }
      };
      const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    return (
        <div className="mt100 container">
            <div className="mt-2">
                {loading ? (
                    <p>載入中...</p>
                ) : (
                    <table className="table table-striped border table-responsive">
                        <thead>
                            <tr>
                                <th>學員姓名</th>
                                <th>科目</th>
                                <th>證明文件</th>
                                <th>軟體到期日</th>
                                <th>狀態</th>
                                <th>申請日期</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requestList.map((request) => (
                                <tr key={request.request_id}>
                                    <td>{request.student_name}</td>
                                    <td>{request.subject}</td>
                                    <td>
                                        {request.proof_file ? (
                                            <a
                                                href={`${backend}${request.proof_file}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                檢視文件
                                            </a>
                                        ) : (
                                            "無"
                                        )}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="current_expiry"
                                                value={dateHelper(updatedData.current_expiry, "date")}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            dateHelper(request.current_expiry, "date")
                                        )}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <select
                                                className="form-control"
                                                name="status"
                                                value={updatedData.status}
                                                onChange={handleInputChange}
                                            >
                                                <option value="審核中">審核中</option>
                                                <option value="已核准">已核准</option>
                                                <option value="已拒絕">已拒絕</option>
                                            </select>
                                        ) : (
                                            request.status
                                        )}
                                    </td>
                                    <td>
                                        {request.timestamp}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="memo"
                                                value={updatedData.memo}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            request.memo
                                        )}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <>
                                                <button className="btn btn-primary me-2" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </>
                                        ) : (
                                            <button className="btn btn-primary" onClick={() => startEditing(request)}>
                                                編輯
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default ExtendRequest;